import { BbitLanguage, BbitTranslationType, IBbitTranslation } from '@bbitgmbh/bbit.utils';

export const translations: IBbitTranslation[] = [
  {
    key: 'notInStock',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Lieferfrist auf Anfrage',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Delivery time on request',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Délai de livraison sur demande',
      },
    },
  },
  {
    key: 'reserved',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Reserviert',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Reserved',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réservé',
      },
    },
  },
  {
    key: 'yourReservation',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Ihre Reservation',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Your reservation',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Votre réservation',
      },
    },
  },
  {
    key: 'companion',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Begleitpersonen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Companions',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Accompagnateurs',
      },
    },
  },
  {
    key: 'closed',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Geschlossen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Closed',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Fermé',
      },
    },
  },
  {
    key: 'placeBooking',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Platzbuchungen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Place bookings',
      },
    },
  },
  {
    key: 'blocked',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Blockiert',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Blocked',
      },
    },
  },
  {
    key: 'facilityClosed',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Die Anlage ist am %0 geschlossen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'The facility is closed on %0',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "L'installation est fermée le %0",
      },
    },
  },
  {
    key: 'facilityBlocked',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Die Anlage ist für Buchungen am %0 gesperrt',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'The facility is blocked for bookings on %0',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "L'installation est bloquée pour les réservations le %0",
      },
    },
  },
  {
    key: 'onlineBooking',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Online-Buchung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Online Booking',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réservation en ligne',
      },
    },
  },
  {
    key: 'pleaseLogin',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Bitte melden Sie sich an um mit der Buchung fortzufahren.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Please log in to continue with the booking.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Veuillez vous connecter pour continuer avec la réservation.',
      },
    },
  },
  {
    key: 'login',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Anmelden',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Login',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Se connecter',
      },
    },
  },
  {
    key: 'bookEvent',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: '%0 buchen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Book %0',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réserver %0',
      },
    },
  },
  {
    key: 'bookingSuccess',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Ihre Buchung wurde erfolgreich erstellt',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Your booking has been successfully created',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Votre réservation a été créée avec succès',
      },
    },
  },
  {
    key: 'bookingConfirmationEmail',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Sie erhalten in Kürze eine Bestätigung Ihrere Buchung per E-Mail',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'You will receive a confirmation of your booking by email shortly',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Vous recevrez bientôt une confirmation de votre réservation par e-mail',
      },
    },
  },
  {
    key: 'close',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Schliessen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Close',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Fermer',
      },
    },
  },
  {
    key: 'bookingError',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Fehler beim Erstellen der Buchung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Error creating the booking',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Erreur lors de la création de la réservation',
      },
    },
  },
  {
    key: 'redirectToPayment',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Sie werden in Kürze zur Zahlungsseite weitergeleitet...',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'You will be redirected to the payment page shortly...',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Vous serez redirigé vers la page de paiement sous peu...',
      },
    },
  },
  {
    key: 'pleaseWait',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Bitte warten...',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Please wait...',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Veuillez patienter...',
      },
    },
  },
  {
    key: 'fillAllValues',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Bitte alle Werte ausfüllen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Please fill in all values',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Veuillez remplir toutes les valeurs',
      },
    },
  },
  {
    key: 'priceCalculationError',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Fehler beim Berechnen des Preises',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Error calculating the price',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Erreur lors du calcul du prix',
      },
    },
  },
  {
    key: 'priceInclVat',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Preis inkl. MWST',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Price incl. VAT',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Prix TTC',
      },
    },
  },
  {
    key: 'completeBookingConditions',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Um die Buchung abzuschliessen, müssen folgende Bedingungen akzeptiert werden:',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'To complete the booking, the following conditions must be accepted:',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Pour compléter la réservation, les conditions suivantes doivent être acceptées:',
      },
    },
  },
  {
    key: 'gtc',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Allgemeine Geschäftsbedingungen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'General Terms and Conditions',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Conditions générales',
      },
    },
  },
  {
    key: 'download',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'herunterladen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'download',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'télécharger',
      },
    },
  },
  {
    key: 'book',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Buchen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Book',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réserver',
      },
    },
  },
  {
    key: 'cancel',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Stornieren',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Cancel',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Annuler',
      },
    },
  },
  {
    key: 'shootingRange',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Schiessanlage',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Shooting Range',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Stand de tir',
      },
    },
  },
  {
    key: 'intro',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Intro',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Intro',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Intro',
      },
    },
  },
  {
    key: 'offers',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Angebote',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Offers',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Offres',
      },
    },
  },
  {
    key: 'credit',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Guthaben',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Credit',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Crédit',
      },
    },
  },
  {
    key: 'book',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Buchen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Book',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réserver',
      },
    },
  },
  {
    key: 'bookHall',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Halle buchen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Book Hall',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réserver la salle',
      },
    },
  },
  {
    key: 'usageType',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Nutzungsart',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Usage type',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Type d'utilisation",
      },
    },
  },
  {
    key: 'bookingDuration',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Buchungszeitraum',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Booking duration',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Durée de réservation',
      },
    },
  },
  {
    key: 'newReservation',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Neue Reservation',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'New reservation',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nouvelle réservation',
      },
    },
  },
  {
    key: 'reservationNoLongerPossible',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Reservation nicht mehr möglich',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Reservation no longer possible',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réservation plus possible',
      },
    },
  },
  {
    key: 'acceptConditions',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Um die Buchung abzuschliessen, müssen folgende Bedingungen akzeptiert werden:',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'To complete the booking, the following conditions must be accepted:',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Pour finaliser la réservation, les conditions suivantes doivent être acceptées:',
      },
    },
  },
  {
    key: 'changeEMail',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'E-Mail ändern',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Change e-mail',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Changer l`adresse e-mail',
      },
    },
  },
  {
    key: 'changePassword',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Passwort ändern',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Change password',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Changer le mot de passe',
      },
    },
  },
  {
    key: 'createNewBooking',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Neue Buchung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'New booking',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nouvelle réservation',
      },
    },
  },
  {
    key: 'noEntries',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Keine Einträge',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'No entries',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Pas d`entrées',
      },
    },
  },
  {
    key: 'errorLoading',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Fehler beim laden der Daten',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Error loading the data.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Erreur lors du chargement des données.',
      },
    },
  },
  {
    key: 'cancellationError',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Stornierung nicht möglich',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Cancellation not possible',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Annulation non possible',
      },
    },
  },
  {
    key: 'abort',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Abbrechen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Abort',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Abandonner',
      },
    },
  },
  {
    key: 'place',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Platz',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Place',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Place',
      },
    },
  },
  {
    key: 'cancelBooking',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Buchung stornieren',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Cancel booking',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Annuler la réservation',
      },
    },
  },
  {
    key: 'cancellationNotPossible',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Stornierung nicht möglich',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Cancellation not possible',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Annulation impossible',
      },
    },
  },
  {
    key: 'cancellationSuccess',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Stornierung erfolgreich',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Cancellation successful',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Annulation réussie',
      },
    },
  },
];
